module.exports = __webpack_public_path__ + "img/res.bcd8c291.png";